/** Header-action builder for the Tasks view.
 *  Owns: Search, Filters, and New Task. All actions fire window events
 *  that the TaskManager feature listens for. No JSX. */

import { Search, SlidersHorizontal, Plus } from '@/shared/ui/icons';
import type { MobileHeaderAction } from './types';

export interface TasksHeaderCtx {
  leadingActions: MobileHeaderAction[];
  trailingActions: MobileHeaderAction[];
  pushNotificationsAction: () => void;
  pushBackAction: (targetView: string, label: string, onClickOverride?: () => void) => void;
}

/** Appends Tasks pills to the caller's leading/trailing action arrays.
 *  Called only when `currentView === 'tasks'`. */
export function buildTasksHeaderActions(ctx: TasksHeaderCtx): void {
  const { leadingActions, trailingActions, pushNotificationsAction, pushBackAction } = ctx;

  pushBackAction('dashboard', 'Back to dashboard');
  leadingActions.push({
    id: 'tasks-search',
    icon: Search,
    ariaLabel: 'Search tasks',
    onClick: () => window.dispatchEvent(new CustomEvent('tasks:toggle-search')),
  });
  // Filters are view configuration, not navigation → trailing. Apple's leading
  // edge is a closed list (back/dismiss, sidebar toggle, title, document menu).
  trailingActions.push({
    id: 'tasks-filters',
    icon: SlidersHorizontal,
    ariaLabel: 'Filters',
    onClick: () => window.dispatchEvent(new CustomEvent('tasks:open-filters')),
    group: 'view',
  });
  trailingActions.push({
    id: 'tasks-add',
    icon: Plus,
    ariaLabel: 'New task',
    onClick: () => window.dispatchEvent(new CustomEvent('tasks:create-new')),
    group: 'page',
  });
  pushNotificationsAction();
}
